<!-- Start Testimonial Videos Area -->
<section class="testimonial-videos-area pt-100">
  <div class="container">
    <div class="section-title text-center mb-4">
      <span class="title-badge">CUSTOMER STORIES</span>
      <h2 class="section-heading">Hear From Our Happy Clients</h2>
      <p class="section-subheading">
        Discover why homeowners and builders trust Chennai's biggest tiles collection showroom for their dream projects
      </p>
    </div>

    <div class="testimonial-videos-slider position-relative">
      <!-- Left Arrow Button -->
      <button class="carousel-arrow left" (click)="testimonialCarousel?.prev()">
        <i class='bx bx-chevron-left'></i>
      </button>

      <!-- Right Arrow Button -->
      <button class="carousel-arrow right" (click)="testimonialCarousel?.next()">
        <i class='bx bx-chevron-right'></i>
      </button>

      <owl-carousel-o #testimonialCarousel [options]="videoSliderOptions">
        <ng-template carouselSlide *ngFor="let video of videoSlides">
          <div class="video-slide">
            <div class="video-card">
              <a [href]="'https://www.youtube.com/watch?v=' + video.id" class="video-thumbnail-wrapper popup-youtube">
                <img [src]="getThumbnailUrl(video.id)" alt="Customer Testimonial" class="video-thumbnail" />
                <div class="play-overlay">
                  <i class='bx bx-play'></i>
                </div>
                <div class="video-overlay">
                  <div class="video-content">
                    <h4>{{ video.title }}</h4>
                    <p>{{ video.description }}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>
